(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const gallerySelector = '.product-information__media media-gallery';
    const zoomableSelector = '.product-media-container--zoomable';

    const isDesktopHoverDevice = () =>
      window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;

    const setZoomOrigin = (container, clientX, clientY) => {
      const rect = container.getBoundingClientRect();

      const x = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((clientY - rect.top) / rect.height) * 100));

      container.style.setProperty('--inline-zoom-x', `${x}%`);
      container.style.setProperty('--inline-zoom-y', `${y}%`);
    };

    const resetZoomOrigin = (container) => {
      container.style.setProperty('--inline-zoom-x', '50%');
      container.style.setProperty('--inline-zoom-y', '50%');
    };

    const disableThemePopup = (root = document) => {
      root.querySelectorAll(`${gallerySelector} ${zoomableSelector}`).forEach((container) => {
        if (container.closest('.dialog-zoomed-gallery')) return;

        /* Remove Horizon's native popup/preload actions */
        [container, ...container.querySelectorAll('[on\\:click], [on\\:pointerenter]')].forEach(
          (element) => {
            const clickAction = element.getAttribute?.('on:click') || '';
            const pointerAction = element.getAttribute?.('on:pointerenter') || '';

            if (clickAction.toLowerCase().includes('zoom')) {
              element.removeAttribute('on:click');
            }

            if (pointerAction.toLowerCase().includes('preloadimage')) {
              element.removeAttribute('on:pointerenter');
            }
          }
        );

        const button = container.querySelector('.product-media-container__zoom-button');

        if (button) {
          button.setAttribute('aria-label', 'Zoom product image');
          button.setAttribute(
            'aria-pressed',
            container.classList.contains('inline-zoom-active') ? 'true' : 'false'
          );
        }
      });

      /* Close the native dialog if the theme opens it during a re-render */
      root.querySelectorAll("zoom-dialog[id^='zoom-dialog-'] dialog[open]").forEach((dialog) => {
        try {
          dialog.close();
        } catch (error) {
          dialog.removeAttribute('open');
        }
      });

      document.documentElement.classList.remove('scroll-lock');
      document.body?.classList.remove('scroll-lock');
    };

    /* Desktop mouse movement controls the visible zoomed area */
    document.addEventListener('pointermove', (event) => {
      if (!isDesktopHoverDevice() || event.pointerType === 'touch') return;

      const container = event.target.closest?.(`${gallerySelector} ${zoomableSelector}`);
      if (!container || container.closest('.dialog-zoomed-gallery')) return;

      setZoomOrigin(container, event.clientX, event.clientY);
    });

    document.addEventListener('pointerleave', (event) => {
      const container = event.target.closest?.(`${gallerySelector} ${zoomableSelector}`);
      if (container) resetZoomOrigin(container);
    }, true);

    /* Block the popup click. On touch devices, use tap-to-zoom instead. */
    document.addEventListener(
      'click',
      (event) => {
        const container = event.target.closest?.(`${gallerySelector} ${zoomableSelector}`);
        if (!container || container.closest('.dialog-zoomed-gallery')) return;

        if (
          event.target.closest(
            'video, iframe, model-viewer, deferred-media, slideshow-arrows, .slideshow-controls, .media-gallery__mobile-controls'
          )
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (isDesktopHoverDevice()) {
          return;
        }

        document
          .querySelectorAll(`${gallerySelector} ${zoomableSelector}.inline-zoom-active`)
          .forEach((otherContainer) => {
            if (otherContainer !== container) {
              otherContainer.classList.remove('inline-zoom-active');
              resetZoomOrigin(otherContainer);
            }
          });

        const active = container.classList.toggle('inline-zoom-active');

        if (active && event.clientX && event.clientY) {
          setZoomOrigin(container, event.clientX, event.clientY);
        } else if (!active) {
          resetZoomOrigin(container);
        }

        container
          .querySelector('.product-media-container__zoom-button')
          ?.setAttribute('aria-pressed', active ? 'true' : 'false');
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document
        .querySelectorAll(`${gallerySelector} ${zoomableSelector}.inline-zoom-active`)
        .forEach((container) => {
          container.classList.remove('inline-zoom-active');
          resetZoomOrigin(container);
        });
    });

    const initialize = () => disableThemePopup(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', initialize);

    new MutationObserver(() => disableThemePopup(document)).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
